import { of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Contacts, RecentUsers, UserData } from '../data/users';
import { CookieService } from 'ngx-cookie';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class UserService extends UserData {
  private time: Date = new Date;
  nomeUtente = '';
  errorMessage = '';
  showErrorMessage = false;
  idUser = '';

  private users = {
    loggedUser: { name: '', picture: '' },
  };

  private types = {
    mobile: 'mobile',
    home: 'home',
    work: 'work',
  };

  private contacts: Contacts[] = [
    /*
    { user: this.users.nick, type: this.types.mobile },
    { user: this.users.eva, type: this.types.home },
    { user: this.users.jack, type: this.types.mobile },
    { user: this.users.lee, type: this.types.mobile },
    { user: this.users.alan, type: this.types.home },
    { user: this.users.kate, type: this.types.work },
    */
  ];

  private recentUsers: RecentUsers[]  = [
    /*
    { user: this.users.alan, type: this.types.home, time: this.time.setHours(21, 12)},
    { user: this.users.eva, type: this.types.home, time: this.time.setHours(17, 45)},
    { user: this.users.nick, type: this.types.mobile, time: this.time.setHours(5, 29)},
    { user: this.users.lee, type: this.types.mobile, time: this.time.setHours(11, 24)},
    { user: this.users.jack, type: this.types.mobile, time: this.time.setHours(10, 45)},
    { user: this.users.kate, type: this.types.work, time: this.time.setHours(9, 42)},
    { user: this.users.kate, type: this.types.work, time: this.time.setHours(9, 31)},
    { user: this.users.jack, type: this.types.mobile, time: this.time.setHours(8, 0)},
    */
  ];

  constructor(
    public auth: AuthService,
    public cookieService: CookieService,
  ) {
    super();
  }

  getUsers(): Observable<any> {
    return observableOf(this.users);
  }

  getContacts(): Observable<Contacts[]> {
    return observableOf(this.contacts);
  }

  getRecentUsers(): Observable<RecentUsers[]> {
    return observableOf(this.recentUsers);
  }

  loadSingleUser(): Observable<any> {
    this.idUser = this.cookieService.get('id');
    this.auth.detailUser(this.idUser).then(
      (data) => {
        this.users.loggedUser['name'] = data.data.nome + ' ' + data.data.cognome;
        if (data.data.avatar == '' || data.data.avatar == null || data.data.avatar == undefined)
        {
          this.users.loggedUser['picture'] = 'assets/images/avatar.png';
        } else {
          this.users.loggedUser['picture'] = data.data.avatar;
        }
      },
      (error) => {
        console.error('Errore', error);
        this.showErrorMessage = true;
        this.errorMessage = 'Errore API listUser';
      },
    );
    return observableOf(this.users);
  }
}
